import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'g-drag-block',
  props: {
    left: { default: '100px' },
    top: { default: '100px' },
    zIndex: { default: 9999 },
    clamp: { type: Boolean, default: false }
  },
  emits: ['onMouseDown', 'onMouseUp', 'onMouseMove'],
  setup(__props: any, { emit: emits }) {

const props = __props as { left: string, top: string, zIndex: number, clamp: boolean }





const isDrag = ref(false)
const dragRef = ref<HTMLDivElement>()
const offset = ref({
  left: 0,
  top: 0,
})

const posi = ref({
  left: props.left,
  top: props.top,
})

const style = computed(() => {
  return {
    ...posi.value,
  }
})

onMounted(() => {
  window.addEventListener('mousemove', handleMouseMoveBall)
  window.addEventListener('mouseup', globalMouseUp)
})
onUnmounted(() => {
  window.removeEventListener('mousemove', handleMouseMoveBall)
  window.removeEventListener('mouseup', globalMouseUp)
})

function handleMouseDownBall(e: MouseEvent) {
  isDrag.value = true
  const { x, y } = dragRef.value!.getBoundingClientRect()
  offset.value.left = e.clientX - x
  offset.value.top = e.clientY - y
  emits('onMouseDown', { e })
}
function handleMouseUpBall(e: MouseEvent) {
  isDrag.value = false
  emits('onMouseUp', { e })
}

function handleMouseMoveBall(e: MouseEvent) {
  if (!isDrag.value) return
  let left = e.clientX - offset.value.left
  let top = e.clientY - offset.value.top
  const dragEl = dragRef.value
  if (props.clamp && dragEl) {
    left = Math.min(Math.max(0, left), window.innerWidth - dragEl.offsetWidth)
    top = Math.min(Math.max(0, top), window.innerHeight - dragEl.offsetHeight)
  }
  posi.value.left = left + 'px'
  posi.value.top = top + 'px'
  emits('onMouseMove', { e })
}

function globalMouseUp() {
  isDrag.value = false
}

return { __sfc: true,props, emits, isDrag, dragRef, offset, posi, style, handleMouseDownBall, handleMouseUpBall, handleMouseMoveBall, globalMouseUp }
}

})